<template>
  <div class="input-fields-item">
    <label class="paragraph-s paragraph-dark-gray">{{ filterConfig.label }}</label>
    <multiselect-field
      :placeholder="placeholder"
      :options="filterOptions"
      :value="activeFilters"
      :multiple="true"
      :iconField="true"
      :disabled="isDisable"
      :close-on-select="false"
      :clear-on-select="true"
      :showOptionsList="true"
      :isPositionFixed="false"
      :taggable="false"
      :hide-selected="true"
      :isCapitalizedTags="false"
      :showLabels="false"
      :searchable="true"
      :show-no-results="true"
      track-by="value"
      label="name"
      open-direction="bottom"
      @select="addFilter"
      @remove="removeFilter"
      @blur="blur"
    >
      <div slot="option" slot-scope="props">
        <div class="option-flex-row">
          <span>{{ props.option.name }}</span>
          <span v-if="activeFiltersExists" class="option-counter">+{{ props.option.count }}</span>
          <span v-else class="option-counter">{{ props.option.count }}</span>
        </div>
      </div>
      <template slot="multiselect-icon">
        <div class="tag-icon">
          <svg-icon :name="filterConfig.icon" width="16" height="16"></svg-icon>
        </div>
      </template>
    </multiselect-field>
  </div>
</template>

<script>

import {forEach, isEmpty} from 'lodash';
import MultiselectField from 'top20common/components/MultiselectField';
export default {
  props: {
    filterConfig: {type: Object},
    filterOptions: {type: Array},
    activeFilters: {type: Array},
    isDisable: {type: Boolean, default: false},
    placeholder: {type: String, default: ''}
  },
  created() {
    require(`top20common/distribution/icons/${this.filterConfig.icon}`);
  },
  data() {
    return {
      hasChanges: false
    };
  },
  computed: {
    getSelection() {
      let items = [];
      forEach(this.activeFilters, option => {
        if (this.filterOptions.includes(option.value)) {
          items.push(option);
        }
      });
      return items;
    },
    activeFiltersExists() {
      return !isEmpty(this.activeFilters);
    }
  },
  methods: {
    addFilter(event) {
      this.hasChanges = true;
      this.$emit('add-filter', this.filterConfig.type, event);
    },
    removeFilter(event) {
      if (event) {
        this.$emit('remove-filter', this.filterConfig.type, event);
      }
    },
    blur(event) {
      if (this.hasChanges) {
        this.$emit('blur', this.filterConfig.type, event);
        this.hasChanges = false;
      }
    }
  },
  components: {MultiselectField}
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.option-counter {
  float: right;
}

.tag-icon /deep/ .svg-icon {
  color: var(--gray);
}

/deep/ .multiselect__content-wrapper {
  width: 100%;
}
.option-flex-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
